export default __webpack_public_path__ + "static/media/bnr5.b8d782f3.jpg";